import { App } from "antd";
import { ReactNode, useState } from "react";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import Profile from "./tabs/profile";
import useCurrentUser from "../../hooks/useCurrentUser";
import Security from "./tabs/security";
import DoctorPayments from "./tabs/doctorPayments";
import PatientPayments from "./tabs/patientPayments";
import { DELETE_USER } from "./settings.gql";

const useSettings = () => {
  const { t } = useTranslation();
  const { fullName, isDoctor } = useCurrentUser();
  const [isEliminatePopupVisible, setIsEliminatePopupVisible] = useState(false);
  const { message } = App.useApp();
  const { refetchUser } = useCurrentUser();

  const globalTabs = [
    {
      key: "profile",
      tab: t("settingsPage.profile.tabLabel"),
    },
    {
      key: "security",
      tab: t("settingsPage.security.tabLabel"),
    }
  ];

  const tabList = [
    ...globalTabs,
    ...(isDoctor ? [] : [{
      key: "payments",
      tab: t("settingsPage.payment.tabLabel"),
    }])
  ];

  const [activeTabKey, setActiveTabKey] = useState<string>(tabList[0].key);

  const [deleteUser, { loading }] = useMutation(DELETE_USER, {
    fetchPolicy: "no-cache",
    onCompleted: () => {
      refetchUser();
      message.success(t("user.success.deleteUser"));
    },
    onError: ({ graphQLErrors }) => {
      message.error(graphQLErrors[0].message);
    }
  });

  const contentList: Record<string, ReactNode> = {
    profile: <Profile/>,
    security: <Security/>,
    payments: isDoctor ? <DoctorPayments/> : <PatientPayments/>,
  };

  const onTabChange = (key: string) => {
    setActiveTabKey(key);
  };

  const onSubmitForm = () => deleteUser();

  return {
    fullName,
    isDoctor,
    isEliminatePopupVisible,
    setIsEliminatePopupVisible,
    tabList,
    activeTabKey,
    contentList,
    onTabChange,
    loading,
    onSubmitForm,
  };
};

export default useSettings;
